import { css } from '@emotion/css';
import { Colors } from './colors';
import { HEADER_HEIGHT } from './css-values';
import { p2Style } from './text';

/**
 * Shared layout for the authentication screens: heading + fields at the top,
 * back / next actions pinned to the bottom of the viewport.
 */
export const authFormContentStyle = css`
  min-height: calc(100vh - ${HEADER_HEIGHT});
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: calc(2rem + env(safe-area-inset-bottom, 0px));
`;

export const authHeaderStyle = css`
  margin-bottom: 0.75rem;
`;

export const authSubtitleStyle = css`
  ${p2Style}
  color: ${Colors.TEXT_SECONDARY};
  margin-bottom: 2rem;
`;

export const authButtonContainerStyle = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-top: 1.5rem;
`;

export const authInlineLinkStyle = css`
  font-family: Doctrine;
  font-style: normal;
  font-weight: bold;
  font-size: 0.9375rem;
  line-height: 120%;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${Colors.CAPRI_BLUE};
  padding: 0.5rem 0;
  display: inline-block;
  cursor: pointer;
  border-radius: 0.25rem;

  @media (hover: hover) {
    &:hover {
      color: ${Colors.CAPRI_BLUE_DARK};
      text-decoration: underline;
      text-underline-offset: 0.2em;
    }
  }
`;
